// Enum values (mirror the Prisma enums). The words for each value live in
// constants/broadcastText.js — t.categories[c], t.statuses[s], …
export const CATEGORIES = [
  "VERSION_UPDATE",
  "SCHEDULED_MAINTENANCE",
  "UNPLANNED_DOWNTIME",
  "SERVICE_RESTORED",
  "DEGRADED_PERFORMANCE",
  "SECURITY_NOTICE",
  "POLICY_UPDATE",
  "HOLIDAY_CLOSURE",
  "PAYROLL_NOTICE",
  "NEW_FEATURE",
  "EMERGENCY",
  "GENERAL",
];
export const SEVERITIES = ["INFO", "SUCCESS", "WARNING", "CRITICAL"];
export const DISPLAY_MODES = ["BANNER", "TOAST", "MODAL"];
export const TARGETABLE_ROLES = ["superadmin", "admin", "manager", "user"];
export const VARIABLE_TYPES = ["text", "datetime", "number"];

export const STATUS_COLORS = {
  DRAFT: "#64748b",
  SCHEDULED: "#7c3aed",
  SENDING: "#0ea5e9",
  SENT: "#10b981",
  CANCELLED: "#94a3b8",
  FAILED: "#dc2626",
  EXPIRED: "#94a3b8",
};
export const STATUSES = ["DRAFT", "SCHEDULED", "SENDING", "SENT", "CANCELLED", "FAILED"];
